import { settings } from 'settings';
import Fetch from 'utils/fetch';

export async function fetchEditCourierAreaByCourierId(
  courierIdToUpdate: number,
  editedAreaList: string[],
  noteToUpdate: string
): Promise<boolean> {
  console.log('editedAreaList', editedAreaList);
  console.log('courierIdToUpdate', courierIdToUpdate);
  try {
    const response: Response = await Fetch.post({
      url: `${settings.newApiUrl}/courier/updateCourierAreaByCourierId`,

      body: {
        editedAreaList: editedAreaList,
        courierIdToUpdate: courierIdToUpdate,
        noteToUpdate: noteToUpdate,
      },
    });

    if (response.ok) {
      return true;
    }
  } catch (error) {
    return false;
  }
}
